import { useState } from 'react';
import { Layout, Tooltip, Switch, Space } from 'antd';
import { useConcent } from 'concent';
import { connect } from 'react-redux';
import { EyeOutlined, SunOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';

import UserInfo from 'components/UserInfo';
import HeadMenu from 'components/HeadMenu';
import { IsFixedRowHeight } from 'constants/common';
import ApplyAuthModal from 'components/ApplyAuthModal';

import './index.less';

const { Header } = Layout;
interface RootState {
  localTheme: string;
  isFixedRowHeight: string;
}
interface RootDispatch {
  setReduxData: Function;
}
type Props = {
  menus: any;
  selectedKey: string;
  pathname: string;
} & RootState &
  RootDispatch;

const mapState = (state: { layouts: RootState }) => {
  const { localTheme, isFixedRowHeight } = state.layouts;
  return { localTheme, isFixedRowHeight };
};

const mapDispatch = (dispatch: { layouts: RootDispatch }) => {
  const { setReduxData } = dispatch.layouts;
  return {
    setReduxData,
  };
};

function Headers(props: Props) {
  const userCtx = useConcent({ module: 'user' });
  const { menus, selectedKey } = props;
  const { userId, authList } = userCtx.state;
  const [isShowModal, setIsShowModal] = useState(false);
  const onLogoClick = () => {
    window.location.href = `${window.location.origin}/`;
  };

  const toggleTheme = () => {
    const localTheme = localStorage.getItem('localTheme');
    const newTheme = localTheme === 'protect' ? 'light' : 'protect';
    localStorage.setItem('localTheme', newTheme);
    props.setReduxData({ key: 'localTheme', data: newTheme });
  };

  const toggleFixedRow = () => {
    const isFixedRowHeight = localStorage.getItem('isFixedRowHeight');
    const newChoice = isFixedRowHeight === IsFixedRowHeight.Fixed ? IsFixedRowHeight.Auto : IsFixedRowHeight.Fixed;
    localStorage.setItem('isFixedRowHeight', newChoice);
    props.setReduxData({ key: 'isFixedRowHeight', data: newChoice });
  };

  const showApplyModal = () => {
    setIsShowModal(true);
  };

  const hideApplyModal = () => {
    setIsShowModal(false);
  };

  return (
    <Header className='head-box'>
      <div className='logo-cont' onClick={onLogoClick}>
        <h3 className='title'>语料生产系统</h3>
      </div>

      {authList?.length > 0 && userId ? (
        <div className='head-menu-wrapper'>
          <HeadMenu menus={menus} selectedKey={selectedKey} authList={authList} userId={userId}></HeadMenu>
        </div>
      ) : null}

      <div className='user-box'>
        {authList?.length > 0 ? (
          <>
            <Space>
              <Tooltip title={props.isFixedRowHeight === IsFixedRowHeight.Fixed ? '解除固定' : '固定行高'}>
                <Switch
                  checkedChildren={<LockOutlined />}
                  unCheckedChildren={<UnlockOutlined />}
                  onChange={toggleFixedRow}
                  defaultValue={localStorage.getItem('isFixedRowHeight') === IsFixedRowHeight.Fixed}
                />
              </Tooltip>
              <Tooltip title={localStorage.getItem('localTheme') === 'protect' ? '关闭护眼模式' : '开启护眼模式'}>
                <Switch
                  checkedChildren={<EyeOutlined />}
                  unCheckedChildren={<SunOutlined />}
                  onChange={toggleTheme}
                  defaultValue={localStorage.getItem('localTheme') === 'protect'}
                />
              </Tooltip>
            </Space>

            {userId && (
              <Space className='tool-container'>
                <a
                  href='https://doc.weixin.qq.com/doc/w3_AbkAigYpAAYMpD3UvnOQiWpmjXBOq?scode=AJEAIQdfAAoyZ1IqNwAbkAigYpAAY'
                  target='_blank' rel="noreferrer"
                >
                  使用文档
                </a>
                <a onClick={showApplyModal}>权限申请</a>
              </Space>
            )}
          </>
        ) : null}

        <UserInfo></UserInfo>
      </div>
      <ApplyAuthModal isShowModal={isShowModal} hideApplyModal={hideApplyModal} />
    </Header>
  );
}

export default connect(mapState, mapDispatch)(Headers);
